export enum User {
    GROWER = "Grower",
    STAFF = "Staff"
}